import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-objects-this-predict',
  slug: 'this-predict',
  title: 'Who is this?',
  type: 'predict',
  estSeconds: 90,
  contentVersion: 1,
});
